import { render, staticRenderFns } from "./Slide.vue?vue&type=template&id=7242350b"
import script from "./Slide.vue?vue&type=script&lang=ts"
export * from "./Slide.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports